import { Stack } from '@mantine/core';
import { useApiListUserLogs, type ActivityLogOut } from '@repo/api-codegen';
import { EntityType } from '@repo/common/enums/entityType';
import type { ApiCatalogSort } from '../../api';
import type { FILTER_OPTIONS_DIVIDER, FilterOption } from '../Filter';
import {
	FilterDropdownType,
	FilterOperator,
	FilterOptionType,
	FilterType,
} from '../Filter';
import {
	buildEntityGetItemsFn,
	buildGetItemsByIdFromSearch,
} from '../Filter/filterConfigUtils';
import { TableV2 } from '../TableV2';
import { useColumns } from './hooks';

const DEFAULT_SORT: ApiCatalogSort = {
	field: 'updated_at',
	order: 'desc',
};

const FILTER_OPTIONS: Array<FilterOption | typeof FILTER_OPTIONS_DIVIDER> = [
	{
		label: 'Date',
		type: FilterOptionType.UPDATED_TIME,
		field: 'updated_at',
		filterDropdownConfig: {
			dropdownType: FilterDropdownType.Date,
			defaultOperator: FilterOperator.IsOnOrBefore,
		},
	},
	{
		label: 'Resource name',
		type: FilterOptionType.RESOURCE_ID,
		field: 'resource_id',
		filterDropdownConfig: {
			searchPlaceholder: 'Search resources',
			multipleCountsSuffix: 'resource',
			dropdownType: FilterDropdownType.List,
			defaultOperator: FilterOperator.Is,
			filterType: FilterType.Multiple,
			getItems: buildEntityGetItemsFn(EntityType.all),
			getItemsById: buildGetItemsByIdFromSearch,
			hasIsNotSetOption: false,
		},
	},
];

export function UserLogs({ userId }: { userId: string }) {
	const columns = useColumns();

	return (
		<Stack spacing="md" py="md">
			<TableV2<ActivityLogOut>
				columns={columns}
				pluralTypeString="logs"
				// @ts-ignore
				usePaginationList={useApiListUserLogs}
				defaultRequiredSearchParams={{
					user_id: userId,
				}}
				defaultSort={DEFAULT_SORT}
				useCodegenListInterface
				withInteractiveHeader={false}
				withStickyColumnBorder={false}
				withFilter
				withFilterOptions={FILTER_OPTIONS}
			/>
		</Stack>
	);
}
